import React, { createContext, PropsWithChildren, useContext, useMemo } from 'react';

import { LocaleServiceV1 } from '@volkswagen-onehub/locale-service';
import { Logger } from '@feature-hub/logger';
import { TrackingServiceV2 } from '@oneaudi/audi-tracking-service';
import { VueFormatterServiceInterfaceV1 } from '@oneaudi/vue-formatter-service';
import { LayerManagerV27 } from '@volkswagen-onehub/layer-manager';

interface FeatureAppEnv {
  featureAppId: string;
  featureAppName?: string;
}

interface ContextState {
  readonly featureAppEnv: FeatureAppEnv;
  readonly localeService?: LocaleServiceV1;
  readonly logger?: Logger;
  readonly trackingService?: TrackingServiceV2;
  readonly vueFormatterService?: VueFormatterServiceInterfaceV1;
  readonly layerManager?: LayerManagerV27;
}

export const Context = createContext<ContextState>({} as ContextState);

export interface ContextProviderProps {
  readonly featureAppEnv: FeatureAppEnv;
  readonly localeService?: LocaleServiceV1;
  readonly logger?: Logger;
  readonly trackingService?: TrackingServiceV2;
  readonly vueFormatterService?: VueFormatterServiceInterfaceV1;
  readonly layerManager?: LayerManagerV27;
}

export const ContextProvider = ({
  children,
  featureAppEnv,
  localeService,
  logger,
  trackingService,
  vueFormatterService,
  layerManager,
}: PropsWithChildren<ContextProviderProps>) => {
  const value = useMemo(
    () => ({
      featureAppEnv,
      localeService,
      logger,
      trackingService,
      vueFormatterService,
      layerManager,
    }),
    [],
  );
  return <Context.Provider value={value}>{children}</Context.Provider>;
};

export const useLogger = () => useContext(Context).logger;
